import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';
import { DOCUMENT } from '@angular/common';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LogIn } from 'src/app/shared/models/user.model';
import { environment } from 'src/environments/environment';
import { MultifactorAuthenticationModel } from 'src/app/shared/models/mfa.model';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MultifactorModalComponent } from '../multifactor-modal/multifactor-modal.component';
import { MfaserviceService } from 'src/app/shared/common/services/mfaservice.service';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  submitted: boolean = false;
  success: boolean = false;
  loading = false;
  invalid: boolean = false;
  //public utility: Utility;
  logged: boolean = false;
  errors: string;
  companyId;
  company_code: string;
  mfastatus = false;
  returnUrl: string;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private fromBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private ngxService: NgxUiLoaderService,
    private modalService: BsModalService,
    public modalRef: BsModalRef,
    private api: MfaserviceService,
    private authenticationService: AuthService,
    private cookieService: CookieService,

  ) {

    this.company_code = environment.companyCode;

  }

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue;
    let islogged = localStorage.getItem('loggedIn');
    let accessmfa = sessionStorage.getItem('accessmfa');
    if (currentUser && currentUser.userName && currentUser.userName !== '') {
      const redirectRoute = islogged === '1' ? 'dashboard' : (accessmfa === '1' ? 'twofactorsettings' : null);

      if (redirectRoute) {
        this.router.navigate([redirectRoute]);
        return true;
      }

    }

    this.renderer.removeClass(this.document.body, 'vertical-layout');
    this.renderer.removeClass(this.document.body, 'vertical-menu');
    this.renderer.removeClass(this.document.body, '2-columns');
    this.renderer.removeClass(this.document.body, 'fixed-navbar');
    this.renderer.removeClass(this.document.body, 'menu-expanded');
    this.renderer.removeClass(this.document.body, 'pace-running');

    this.renderer.addClass(this.document.body, 'bg-full-screen-image');
    this.renderer.addClass(this.document.body, 'vertical-layout');
    this.renderer.addClass(this.document.body, 'vertical-menu');
    this.renderer.addClass(this.document.body, '1-column');
    this.renderer.addClass(this.document.body, 'menu-expanded');
    this.renderer.addClass(this.document.body, 'blank-page');

    this.loginForm = this.fromBuilder.group({
      userName: ['', Validators.required],
      password: ['', Validators.required]
    });

    //this.getMenuList();

  }

  // convenience getter for easy access to form fields
  get inputs() { return this.loginForm.controls; }
  // onSubmit(){
  //   this.openMfaModal();
  // }



  onSubmit() {
    this.submitted = true;
    localStorage.setItem('accessmfa', '0');

    // stop here if form is invalid
    if (this.loginForm.invalid) {
      this.toastr.error("Username/Password is required.");
      //this.invalid = true;
      return;
    }
    else {
      this.ngxService.startLoader('loader-01');
      //this.invalid = false;
    }

    this.loading = true;
    let operatingSystem = 3;
    var login = new LogIn();
    login.userName = this.inputs.userName.value;
    login.passWord = this.inputs.password.value;
    login.companyCode = this.company_code;
    login.operatingSystem = 3;

    this.cookieService.set('password', this.inputs.password.value);
    localStorage.setItem('userName', this.inputs.userName.value);
    localStorage.setItem('companyCode', this.company_code);


    this.authService.UserLogin(login).subscribe(
      (data: any) => {
        this.ngxService.stopLoader('loader-01'); // stop loader early on success

        if (data.isSuccess) {
          const userId = data.data.id;
          const isTwoWay = data.data.isTowWayAuthActivated;

          this.mfastatus = isTwoWay;
          this.cookieService.set('userId', userId);
          localStorage.setItem('CurrentUserId', userId);
          localStorage.setItem("mfastatus", isTwoWay ? "1" : "0");

          if (isTwoWay) {
            this.openMfaModal();
          } else {
            // ✅ Alert only if no MFA, and only after successful login response
            this.toastr.success('Please set up Multi-Factor Authentication.');

            // Optionally wait for Login() to complete
            this.authService.Login(login).subscribe(() => {
              if (data.isSuccess) {
                this.authService.redirectIfAuthWithoutMFA();
                localStorage.setItem('accessmfa', '0');
                sessionStorage.setItem('currentUserToken', data.authToken);
                localStorage.setItem("mfastatus", "0");
                this.toastr.success('Please set up Multi-Factor Authentication.');
              }
            });
          }

          this.companyId = data.data.companyId;
    
        } else {
          this.toastr.error('These credentials do not match our records.');
        }
      },
      (err) => {
        this.toastr.error('Error on login.');
        this.logOutUser();
        this.ngxService.stopLoader('loader-01');
      }
    );
    

  }

  logOutUser() {
    this.authService.logout();
  }

  getMenuList() {
    this.authService.getMenuList()
      .subscribe((data: any) => {
        console.log(data);
        //this.ngxService.stopLoader('loader-01');          
        if (data.error || !data.isSuccess) {
          this.invalid = true;
        }
        else {
          //this.toastr.success('Login success.');
        }
      }, err => {
        //this.ngxService.stop();
        //this.toastr.error('Error on login.');
      });
  }

  redirectIfAuth() {
    let menuList = JSON.parse(localStorage.getItem('menuList'));
    if (menuList[0] && menuList[0].id) {
      //console.log(58963);      
      //console.log(menuList);      
      this.router.navigate(['dashboard'], { queryParams: { business: menuList[0].id } });
    }
  }

  openMfaModal() {
    this.modalRef = this.modalService.show(MultifactorModalComponent, {
      initialState: {
        heading_title: 'Multi-Factor Authentication',
        // business_id:this.business_id,
        data: {
        },
      },
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true,
      class: "modal-s"
    });

    this.modalRef.content.event.subscribe(result => {
      console.log(result);
      if (result == 1) {
        // this.redirectIfAuth();
      }
    });
  }

}
